var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"update-payment"}},[(_vm.payment)?_c('payment-form',{attrs:{"payment-info":_vm.paymentInfoForEdit,"submit":_vm.changePayment}}):_c('a-result',{attrs:{"status":"warning","title":"The payment is not editable"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }